export interface InvoiceI {
  id: number;
  invoiceUrl: string;
  paymentId: number | string;
  totalAmount: number;
  userId: number;
  currency: string;
}

export interface InvoicesStateI {
  invoices: InvoiceI[];
  invoice: InvoiceI;
}

export const state: InvoicesStateI = {
  invoices: [],
  invoice: {
    id: 0,
    invoiceUrl: '',
    paymentId: '',
    totalAmount: 0,
    userId: 0,
    currency: '',
  },
};
